module.exports = __webpack_public_path__ + "media/images/icons/microphone-0761d6526433ce7f5d93c988ba98de44.svg";